export const formatInterval = (value: any) => {
  if (value?.from !== undefined && value?.to !== undefined) {
    if (value.from >= 30) {
      return '30+ days';
    }

    return `${value.from}-${value.to} days`;
  }
  return '';
};
